// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"image-module--imageWrapper--19G5V","image":"image-module--image--7yXa2","loaded":"image-module--loaded--1bGny"};